import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import { useState } from "react";
import { RegionUpdateForm } from "../RegionUpdateForm";
import { assertTypeName } from "../../client/guards";
import { ListFormField } from "../../attributes/list/ListFormField";
import {
  ListType,
  useListRegionEditorSuspenseQuery,
  useUpdateListRegionMutation,
} from "../../client/generated";

type Props = {
  listAttributeId: string;
  dispatch: Dispatch<EditorAction>;
};

export function ListRegionEditor({ listAttributeId, dispatch }: Props) {
  const { data } = useListRegionEditorSuspenseQuery({
    variables: {
      listAttributeId,
    },
  });

  const { listAttr } = data;
  assertTypeName(listAttr?.__typename === "ListAttribute");

  const [updateRegion] = useUpdateListRegionMutation();
  const [listType, setListType] = useState(listAttr.listType);

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    const result = await updateRegion({
      variables: {
        listAttributeId,
        listType,
      },
    });

    return (
      !result.errors && !result.data?.updateListAttribute.userErrors?.length
    );
  };

  return (
    <RegionUpdateForm onSubmit={onSubmit} dispatch={dispatch}>
      <ListFormField
        value={listType}
        onValueChange={(newListType: ListType) => setListType(newListType)}
      />
    </RegionUpdateForm>
  );
}
